import {Component, OnInit, Output, Input, EventEmitter} from '@angular/core';
import {ProfileService} from '../profile.service';

@Component({

    selector: 'main-profile-change-subrole',
    template: require('./profile-change-subrole.component.html'),
    providers: [ProfileService]

})

export class MainProfileChangeSubroleComponent implements OnInit {
                
    @Input('subrole') userSubrole: number;
    @Output('subroleUpdated') subroleUpdated = new EventEmitter();
    accountType: number;
    paymentMethod: number;
    paymentPosted: boolean;
    printMode: boolean;    
    paymentParams = {
        "parameters": "",
        "signature": "",
        "signatureVersion": "",
        "id": 0,
        "code": "",
        "amount": ""
    };

    constructor(private _profileService: ProfileService) {
        this.accountType = 0;
        this.paymentMethod = 0;
        this.paymentPosted = false;
        this.printMode = false;        
    }

    ngOnInit() {
        
    }        

    public changeAccountType(type: number) {
        this.accountType = type;
    }

    public submitPayment() {
        if (this.paymentMethod == 1) {
            this.paymentPosted = true;
        }
        else if (this.paymentMethod == 2) {

        }
        else {

        }
    }

    public changePaymentMethod(method: number) {
        if (this.paymentMethod == 0) {
            this._profileService.createTransaction(this.accountType, method).then(
                res => {
                    this.paymentParams.parameters = res.PARAMS;
                    this.paymentParams.signature = res.SIGNATURE;
                    this.paymentParams.signatureVersion = res.VERSION;
                    this.paymentParams.code = res.TRANSACTION_CODE;
                    this.paymentParams.id = res.TRANSACTION_ID;
                    this.paymentParams.amount = res.TRANSACTION_AMOUNT;
                    this.paymentMethod = method;
                }
            );
        }
        else if (method == this.paymentMethod) { }
        else {
            this._profileService.updateTransaction(this.paymentParams.id, method).then(
                res => {
                    this.paymentMethod = method;
                    this.paymentPosted = false;
                }
            );
        }
    }

    public printBankTransfer() {
        this.printMode = !this.printMode;
    }

    public registerFree() {
        this._profileService.registerFree().subscribe((result) => {                    
            if (result == 1) {                
                this.subroleUpdated.emit({
                    value: true
                })
            } else {
                this.subroleUpdated.emit({
                    value: false
                })
            }
        },() => { });
    }

    public changeSubscription() {
        this.accountType = 0;
        this.paymentMethod = 0;
        this.paymentPosted = false;        
    }    

}


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/main/profile/profile_change_subrole/profile-change-subrole.component.ts
 **/